import { MenuItem, Select } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { JupiterTheme } from '../../../theme/types';
import { RawDataVersion } from './types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    versionsSelect: {
      color: theme.palette.common.white,
    },
  })
);

interface Props {
  rawDataVersions: RawDataVersion[];
  onChange: (selectedComparisonVersion: string) => void;
}

const RawDataComparisonVersionsLoader = ({
  rawDataVersions,
  onChange,
}: Props) => {
  const classes = useStyles();

  const [
    selectedComparisonVersion,
    setSelectedComparisonVersion,
  ] = useState<string>('');

  useEffect(() => {
    setSelectedComparisonVersion('');
  }, [rawDataVersions]);

  function handleSelectVersionChange(event: any) {
    setSelectedComparisonVersion(event.target.value);
    onChange(event.target.value);
  }

  return (
    <Select
      className={classes.versionsSelect}
      value={selectedComparisonVersion}
      displayEmpty={true}
      autoWidth={true}
      onChange={handleSelectVersionChange}
    >
      <MenuItem value="">Compare Versions</MenuItem>

      {rawDataVersions.map((version) => (
        <MenuItem value={version.versionId} key={version.versionId}>
          {new Date(version.lastModifiedTimestamp).toLocaleString()}
        </MenuItem>
      ))}
    </Select>
  );
};
export default RawDataComparisonVersionsLoader;
